import { render, staticRenderFns } from "./JessibucaDemo.vue?vue&type=template&id=2d8aa5b6&scoped=true"
import script from "./JessibucaDemo.vue?vue&type=script&lang=js"
export * from "./JessibucaDemo.vue?vue&type=script&lang=js"
import style0 from "./JessibucaDemo.vue?vue&type=style&index=0&id=2d8aa5b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8aa5b6",
  null
  
)

export default component.exports